export default __webpack_public_path__ + "static/media/ASA.7ae59144.svg";